// Reglas puras de la subida de fotos (photo-field / photo-list): archivo aceptado y mensajes; la lista
// de formatos viene del servidor en el value `accept`. `node --test`.
// Doc: _docs/features/images/photo_field.md

export const MAX_SIZE = 10 * 1024 * 1024

export const UPLOAD_FAILED = "No se pudo subir la imagen. Inténtalo de nuevo."

const FORMAT_LABELS = {
  "image/jpeg": "JPG",
  "image/png": "PNG",
  "image/gif": "GIF",
  "image/webp": "WebP",
  "image/heic": "HEIC",
  "image/heif": "HEIF",
  "image/avif": "AVIF"
}

// Mensaje del rechazo o null: imagen, formato de la lista (si hay) y hasta maxSize
export function validatePhoto(file, maxSize = MAX_SIZE, accept = []) {
  const type = file?.type || ""
  if (!type.startsWith("image/")) return "Solo se permiten imágenes"
  if (accept.length && !accept.includes(type)) return `Formato no admitido. Usa ${formatsLabel(accept)}.`
  if (file.size > maxSize) return `La imagen pesa demasiado. El máximo es ${Math.round(maxSize / (1024 * 1024))} MB.`
  return null
}

// "JPG, PNG o WebP" a partir de los content types
export function formatsLabel(accept) {
  const names = accept.map(type => FORMAT_LABELS[type] || type.replace("image/", "").toUpperCase())
  if (names.length < 2) return names[0] || ""
  return `${names.slice(0, -1).join(", ")} o ${names[names.length - 1]}`
}

export function tooManyPhotos(max) {
  return `Puedes subir hasta ${max} imágenes`
}
